// Favorites Wishlist Management System
(function() {
  // Safe helper to format money based on Shopify settings
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = format || (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    if (!formatString.match(placeholderRegex)) {
      return (cents / 100).toFixed(2);
    }

    function floatToString(numeric) {
      return numeric.toFixed(2);
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = floatToString(cents / 100);
        break;
      case 'amount_no_decimals':
        value = Math.round(cents / 100).toString();
        break;
      case 'amount_with_comma_separator':
        value = floatToString(cents / 100).replace('.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = Math.round(cents / 100).toString().replace('.', ',');
        break;
      default:
        value = floatToString(cents / 100);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Get current favorites array from localStorage (scoped by customerId if logged in)
  function getFavorites() {
    if (!window.customerLoggedIn || !window.customerId) {
      return JSON.parse(localStorage.getItem('favorites_guest') || '[]');
    }
    return JSON.parse(localStorage.getItem('favorites_' + window.customerId) || '[]');
  }

  // Save favorites array to localStorage
  function saveFavorites(favorites) {
    // Unique values check
    const uniqueFavorites = [...new Set(favorites)];
    if (!window.customerLoggedIn || !window.customerId) {
      localStorage.setItem('favorites_guest', JSON.stringify(uniqueFavorites));
    } else {
      localStorage.setItem('favorites_' + window.customerId, JSON.stringify(uniqueFavorites));
      // Sync trigger for customer metafield simulation
      syncFavoritesWithMetafield(uniqueFavorites);
    }
  }

  // Simulated sync of favorites with Shopify Customer Metafields
  function syncFavoritesWithMetafield(favoritesList) {
    console.log('Syncing favorites with customer metafield...', favoritesList);
    // In production, this would perform a secure POST request to an App Proxy endpoint:
    /*
    fetch('/apps/favorites/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: window.customerId,
        favorites: favoritesList
      })
    })
    .then(response => response.json())
    .then(data => console.log('Successfully synced with Shopify backend', data))
    .catch(err => console.error('Metafield sync error:', err));
    */
  }

  // Update UI heart button states across the entire page
  function updateHeartButtons() {
    const favorites = getFavorites();
    
    // Select all favorite buttons (on cards and product pages)
    const cardButtons = document.querySelectorAll('.card-favorite-btn');
    const productButtons = document.querySelectorAll('.product-favorite-btn');

    // Update floating card buttons
    cardButtons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const isFav = favorites.includes(handle);
      const icon = btn.querySelector('.heart-icon');
      
      if (isFav) {
        btn.classList.add('active');
        if (icon) {
          icon.setAttribute('fill', '#E63946');
          icon.style.color = '#E63946';
        }
      } else {
        btn.classList.remove('active');
        if (icon) {
          icon.setAttribute('fill', 'none');
          icon.style.color = '#665C57';
        }
      }
    });

    // Update product detail page buttons
    productButtons.forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const isFav = favorites.includes(handle);
      const icon = btn.querySelector('.heart-icon');
      const textWrapper = btn.querySelector('.favorite-text-wrapper');
      
      const isPT = document.documentElement.lang === 'pt' || document.documentElement.lang.startsWith('pt-');

      if (isFav) {
        btn.classList.add('active');
        if (icon) {
          icon.setAttribute('fill', '#E63946');
          icon.style.color = '#E63946';
        }
        if (textWrapper) {
          textWrapper.textContent = isPT ? 'Remover dos Favoritos' : 'Remove from Favorites';
        }
      } else {
        btn.classList.remove('active');
        if (icon) {
          icon.setAttribute('fill', 'none');
          icon.style.color = 'currentColor';
        }
        if (textWrapper) {
          textWrapper.textContent = isPT ? 'Adicionar aos Favoritos' : 'Add to Favorites';
        }
      }
    });
  }

  // Toggle favorite for a product handle
  function toggleFavorite(handle) {
    if (!handle) return;
    
    if (!window.customerLoggedIn) {
      // Redirect logged-out users to login flow
      const currentUrl = window.location.pathname + window.location.search + window.location.hash;
      const separator = currentUrl.includes('?') ? '&' : '?';
      const redirectUrl = currentUrl + separator + 'add_favorite=' + encodeURIComponent(handle);
      
      // Store redirect target in sessionStorage to prevent loop warning trigger
      sessionStorage.removeItem('attempted_auth_redirect');
      window.location.href = "/customer_authentication/login?return_to=" + encodeURIComponent(redirectUrl);
      return;
    }

    let favorites = getFavorites();
    const index = favorites.indexOf(handle);
    const isRemoving = index > -1;
    
    if (isRemoving) {
      // Remove it
      favorites.splice(index, 1);
    } else {
      // Add it
      favorites.push(handle);
    }
    
    saveFavorites(favorites);
    updateHeartButtons();

    // If we are currently on the dashboard favorites tab
    const favoritesContainer = document.getElementById('FavoritesListContainer');
    const favTab = document.getElementById('Tab-Favorites');
    if (favoritesContainer && favTab && favTab.classList.contains('active')) {
      if (isRemoving) {
        // Remove the card's grid item from the DOM directly — no re-fetch needed
        const cardInGrid = favoritesContainer.querySelector(`[data-product-handle="${handle}"]`);
        if (cardInGrid) {
          const gridItem = cardInGrid.closest('.grid__item') || cardInGrid.closest('li') || cardInGrid.parentElement;
          if (gridItem) {
            gridItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            gridItem.style.opacity = '0';
            gridItem.style.transform = 'scale(0.95)';
            setTimeout(function() {
              gridItem.remove();
              // If no items remain, show the empty state
              const remaining = favoritesContainer.querySelectorAll('.grid__item, li.grid__item');
              if (remaining.length === 0) {
                renderFavoritesTab();
              }
            }, 300);
          }
        }
      } else {
        // On add, re-render to show the newly added product card
        renderFavoritesTab();
      }
    }
  }


  // Render the favorites list dynamically on the dashboard page
  function renderFavoritesTab() {
    const container = document.getElementById('FavoritesListContainer');
    if (!container) return;

    const favorites = getFavorites();
    const isPT = document.documentElement.lang === 'pt' || document.documentElement.lang.startsWith('pt-');

    if (favorites.length === 0) {
      container.innerHTML = `
        <div class="orders-empty-state" style="grid-column: 1 / -1; padding: 60px 20px; text-align: center;">
          <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" style="color: #DCD8D5; margin-bottom: 20px;">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
          <p style="font-size: 16px; color: #665C57; margin-bottom: 24px;">
            ${isPT ? 'Não tem nenhum produto nos favoritos.' : 'You have no favorited products.'}
          </p>
          <a href="/pages/loja" class="button button--secondary">
            ${isPT ? 'Ir para a Loja' : 'Go to Store'}
          </a>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="favorites-loading" style="grid-column: 1 / -1; text-align: center; padding: 40px 0;">
        <span class="loading-overlay__spinner" style="display: inline-block; width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.1); border-top-color: #665C57; border-radius: 50%; animation: spin 1s infinite linear;"></span>
      </div>
    `;

    // Fetch details for all favorited products via Shopify AJAX API concurrently
    const productFetches = favorites.map(handle => 
      fetch(`/products/${handle}?view=card`)
        .then(res => {
          if (!res.ok) throw new Error('Product not found: ' + handle);
          return res.text();
        })
        .catch(err => {
          console.warn(err.message);
          return null; // Return null so promise.all doesn't fail
        })
    );

    Promise.all(productFetches).then(products => {
      // Filter out any failed product fetches
      const validProducts = products.filter(p => p !== null && p.trim() !== '');

      if (validProducts.length === 0) {
        container.innerHTML = `<p style="grid-column: 1 / -1; text-align: center;">${isPT ? 'Ocorreu um erro ao carregar os seus favoritos.' : 'Error loading favorited products.'}</p>`;
        return;
      }

      // Generate HTML string for grid item cards matching the sample products style
      let gridHTML = `<div class="page-width" style="padding-left:0; padding-right:0;"><ul class="grid product-grid contains-card contains-card--product grid--4-col-desktop grid--2-col-tablet-down" role="list" style="width: 100%; list-style: none; padding: 0; margin: 0;">`;
      
      validProducts.forEach((productHTML, index) => {
        gridHTML += `
          <li class="grid__item" style="position: relative; display: flex; flex-direction: column;">
            ${productHTML}
          </li>
        `;
      });

      gridHTML += `</ul></div>`;
      container.innerHTML = gridHTML;

      // Note: Click listeners for floating heart buttons are handled by the document-level 
      // event delegation listener in DOMContentLoaded, so we don't attach them here again.

      
      // Update the heart icons to red since they are all favorites
      updateHeartButtons();

    });
  }

  // Initialize favorites event listeners
  document.addEventListener('DOMContentLoaded', () => {
    // 1. Sync from server-side customer metafields if available (JSON script block)
    const metafieldScript = document.getElementById('customer-favorites-metafield');
    if (metafieldScript && window.customerLoggedIn) {
      try {
        const metafieldList = JSON.parse(metafieldScript.textContent);
        if (Array.isArray(metafieldList)) {
          const currentLocal = getFavorites();
          // Merge local storage wishlist and metafield wishlist
          const merged = [...new Set([...currentLocal, ...metafieldList])];
          saveFavorites(merged);
        }
      } catch (err) {
        console.error('Error parsing customer favorites metafield:', err);
      }
    }

    // 2. Check for URL redirect parameters (?add_favorite=<handle>)
    const urlParams = new URLSearchParams(window.location.search);
    const addHandle = urlParams.get('add_favorite');
    if (addHandle) {
      let favorites = getFavorites();
      if (!favorites.includes(addHandle)) {
        favorites.push(addHandle);
        saveFavorites(favorites);
      }
      // Clean query parameter from URL without page reload
      urlParams.delete('add_favorite');
      const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }

    // 3. Delegation click listener on heart buttons
    document.addEventListener('click', function(e) {
      const targetBtn = e.target.closest('.card-favorite-btn') || e.target.closest('.product-favorite-btn');
      if (targetBtn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = targetBtn.getAttribute('data-product-handle');
        toggleFavorite(handle);
      }
    });

    // 4. Initial UI render
    updateHeartButtons();

    // 5. If we are on the dashboard, hook into tab navigation triggers
    const favTabBtn = document.querySelector('.customer-nav__link[data-target="favorites"]');
    if (favTabBtn) {
      favTabBtn.addEventListener('click', function() {
        renderFavoritesTab();
      });
      
      // Auto-render if page is loaded directly with favorites hash
      if (window.location.hash === '#favorites') {
        renderFavoritesTab();
      }
    }
  });

  // Export helper functions to window for dashboard access
  window.FavoritesWishlist = {
    get: getFavorites,
    toggle: toggleFavorite,
    render: renderFavoritesTab
  };

})();
